import { FOfferType } from '../types';

export const AVAILABLE_OFFER_TYPES: FOfferType[] = Object.keys(FOfferType)
  .filter((key): key is keyof typeof FOfferType => isNaN(+key))
  .map(name => FOfferType[name]);

export const DISJOINT_AVAILABLE_OFFER_TYPES: FOfferType[] = AVAILABLE_OFFER_TYPES.filter(o => Math.log2(o) % 1 === 0);

export const AVAILABLE_OFFER_TYPE_COMBINATIONS: FOfferType[] = [
  FOfferType.Flat,
  FOfferType.Urban & ~FOfferType.Flat,
  FOfferType.Hotel & ~FOfferType.Flat,
  FOfferType.Suburban,
  FOfferType.Other,
  FOfferType.CommercialLand,
  // Классические коммерческие — мульти-выбор через office_type/category.
  // Coworking/Workplace вынесены отдельно: они хранятся в coworking_offer_type
  // и не комбинируются с прочими commercial из-за availability-чека
  // coworking_offer_type (RentLongterm + Coworking|Workplace), который в смешанном
  // состоянии видит office_type первым и сбрасывает coworking_offer_type.
  FOfferType.Commercial & ~FOfferType.CommercialLand & ~FOfferType.Coworking & ~FOfferType.Workplace,
  FOfferType.Coworking | FOfferType.Workplace,
];
